module.exports = __webpack_public_path__ + "static/media/Portfolio_Angela_Ferrari.9cd442c7.pdf";